module.exports = __webpack_public_path__ + "assets/img/11.2cb61b01.png";